module.exports = __webpack_public_path__ + "static/media/KaWineAndDine_Badge_give_back.3de78a42.png";